export const ErrorPage = () => (
        <div className='flex h-full flex-col items-center justify-center'>
            <h1 className='text-4xl font-bold'>Algo ha salido mal</h1>
            <p className='text-lg'>Lo sentimos, ha ocurrido un error. Por favor, inténtelo de nuevo más tarde o llamenos al </p>
            <a href='tel:+34645254587' className='text-blue-500'>
                (+34) 645 254 587
            </a>
        </div>
)
